import { useCallback, useState } from "react";

const useMergeState = (initialState: any) => {
    const [state, setState] = useState(Array.isArray(initialState) ? [...initialState] : initialState || {});

    const mergeState = useCallback((newState: any) => {
        setState((prevState: any) => {
            if (Array.isArray(prevState)) {
                return Array.isArray(newState) ? [...newState] : prevState;
            }
            return { ...prevState, ...newState };
        });
    }, []);

    return [state, mergeState];
};

export default useMergeState;
